import React, { useEffect } from 'react'
import { IDefaultSpecialTerms, TSpecialTermsSchema } from '../../../../../api/types'
import { ErrorBoundary } from '@reapitform/utils'
import { SpecialConditionsForm } from '../special-conditions-contact'
import { useDefaultSpecialConditionPost } from '../../../../../api/defaults/special-terms'
import { Button, ButtonGroup } from '@reapit/elements'
import { Drawer } from '@reapitform/common-ui'

interface IAddSpecialConditionProps {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  refreshList: (data: IDefaultSpecialTerms[] | ((preData: IDefaultSpecialTerms[]) => IDefaultSpecialTerms[])) => void
}

export const AddSpecialCondition: React.FC<IAddSpecialConditionProps> = ({ isOpen, onOpenChange, refreshList }) => {
  const { isLoading, addSpecialCondition, isSuccess, returnData } = useDefaultSpecialConditionPost()
  const formId: string = React.useMemo(() => 'form-add-repairers', [])

  const handleClose = () => onOpenChange(false)
  const handleConfirm = (data: TSpecialTermsSchema) => {
    if (!data.clauses) return
    const clauses: string[] = data.clauses.reduce((result: string[], currentClause) => {
      if (!currentClause.value || typeof currentClause.value !== 'string') return result
      return [...result, currentClause.value]
    }, [])

    addSpecialCondition({
      ...data,
      clauses,
    })
  }

  useEffect(() => {
    if (!isSuccess || !returnData) return

    refreshList((prevData) => [...prevData, returnData])
    handleClose()
  }, [isSuccess, returnData])

  const DrawerFooter = React.useCallback(() => {
    return (
      <ButtonGroup alignment="right">
        <Button intent="default" disabled={isLoading} onClick={handleClose}>
          Cancel
        </Button>
        <Button loading={isLoading} disabled={isLoading} intent="primary" type="submit" form={formId}>
          Add Template
        </Button>
      </ButtonGroup>
    )
  }, [isLoading, handleClose])

  return (
    <ErrorBoundary>
      <Drawer
        isOpen={isOpen}
        onDrawerClose={handleClose}
        title="Create Template"
        canDismiss
        footerItems={<DrawerFooter />}
      >
        <SpecialConditionsForm formId={formId} onSubmit={handleConfirm} />
      </Drawer>
    </ErrorBoundary>
  )
}
